/**
 * Size guide — content lifted from NOT_Size_Guide_Website.pdf.
 *
 * Opens in a slide-over panel so nobody has to leave a product page (or lose
 * their cart) to check a measurement. Triggered by any [data-size-guide]
 * element: the link beside the Size picker, and the one in the footer.
 *
 * Rows are labelled M / L / XL / 2XL to match the size buttons on the product
 * page. The PDF calls the largest one XXL — same size, different label; using
 * the site's own wording keeps the chart and the buttons readable together.
 */
(function () {
  const GUIDE = {
    intro: "Find your fit. Compare your favourite piece. Wear it your way.",
    blocks: [
      {
        name: "Oversized T-Shirt",
        desc: "Oversized, boxy fit with dropped shoulders and wide sleeves.",
        cols: ["Size", "Chest width *", "Length", "Shoulder", "Sleeve"],
        rows: [
          ["M", "61 cm", "72 cm", "59 cm", "22 cm"],
          ["L", "63 cm", "74 cm", "61 cm", "23 cm"],
          ["XL", "65 cm", "76 cm", "63 cm", "24 cm"],
          ["2XL", "67 cm", "78 cm", "65 cm", "25 cm"],
        ],
        note: "* Chest width is measured across the garment, from armpit to armpit.",
        tip: "Want the full oversized look? Stay with your usual size. Prefer a cleaner, less oversized fit? Consider sizing down.",
      },
      {
        name: "Relaxed Shorts",
        desc: "Relaxed, slightly wide fit designed to finish around or just above the knee.",
        cols: ["Size", "Waist relaxed *", "Waist stretched *", "Hip width", "Outseam"],
        rows: [
          ["M", "38 cm", "48 cm", "57 cm", "49 cm"],
          ["L", "40 cm", "50 cm", "59 cm", "50 cm"],
          ["XL", "42 cm", "52 cm", "61 cm", "51 cm"],
          ["2XL", "44 cm", "54 cm", "63 cm", "52 cm"],
        ],
        note: "* Waist and hip measurements are measured across the garment when laid flat.",
        tip: "The elasticated waistband allows additional room between the relaxed and stretched measurements.",
      },
    ],
    checks: [
      "Between sizes? Size up for a more relaxed look. Choose your usual size for the intended fit.",
      "Still unsure? Lay your favourite T-shirt or pair of shorts flat and compare its measurements with the chart above.",
    ],
    footnote: "All measurements are in centimetres (cm). Measurements may vary slightly due to the manufacturing process.",
  };

  function blockHtml(b) {
    return (
      '<section class="sg-block">' +
      '<h3 class="sg-name">' + b.name + "</h3>" +
      '<p class="sg-desc">' + b.desc + "</p>" +
      '<div class="sg-table-wrap"><table class="sg-table"><thead><tr>' +
      b.cols.map(c => "<th>" + c + "</th>").join("") +
      "</tr></thead><tbody>" +
      b.rows
        .map(r => "<tr>" + r.map((c, i) => (i ? "<td>" + c + "</td>" : "<th scope=\"row\">" + c + "</th>")).join("") + "</tr>")
        .join("") +
      "</tbody></table></div>" +
      '<p class="sg-note">' + b.note + "</p>" +
      '<p class="sg-tip"><span>Fit tip</span> ' + b.tip + "</p>" +
      "</section>"
    );
  }

  function build() {
    if (document.querySelector(".sg-panel")) return;
    const wrap = document.createElement("div");
    wrap.innerHTML =
      '<div class="sg-scrim" hidden></div>' +
      '<aside class="sg-panel" hidden role="dialog" aria-modal="true" aria-label="Size guide">' +
      '  <header class="sg-head">' +
      '    <span class="sg-title">Size guide</span>' +
      '    <button type="button" class="sg-close" aria-label="Close size guide">&times;</button>' +
      "  </header>" +
      '  <div class="sg-body">' +
      '    <p class="sg-intro">' + GUIDE.intro + "</p>" +
      GUIDE.blocks.map(blockHtml).join("") +
      '    <section class="sg-block sg-check">' +
      '      <h3 class="sg-name">NOT. fit check</h3>' +
      GUIDE.checks.map(c => '<p class="sg-desc">' + c + "</p>").join("") +
      "    </section>" +
      '    <p class="sg-foot">' + GUIDE.footnote + "</p>" +
      "  </div>" +
      "</aside>";
    while (wrap.firstChild) document.body.appendChild(wrap.firstChild);

    document.querySelector(".sg-scrim").addEventListener("click", close);
    document.querySelector(".sg-close").addEventListener("click", close);
    document.addEventListener("keydown", e => { if (e.key === "Escape") close(); });
  }

  function open(e) {
    if (e) e.preventDefault();
    build();
    document.querySelector(".sg-scrim").hidden = false;
    document.querySelector(".sg-panel").hidden = false;
    requestAnimationFrame(() => document.body.classList.add("sg-open"));
  }

  function close() {
    document.body.classList.remove("sg-open");
    setTimeout(() => {
      const s = document.querySelector(".sg-scrim");
      const p = document.querySelector(".sg-panel");
      if (s) s.hidden = true;
      if (p) p.hidden = true;
    }, 260);
  }

  // Delegated, so triggers rendered later (the product page builds its own
  // markup after this script runs) still work without re-binding.
  document.addEventListener("click", e => {
    if (e.target.closest("[data-size-guide]")) open(e);
  });

  window.NS_SIZE_GUIDE = { open: open, close: close };
})();
